/* ===========================================================================
   EUPHORIA · UPLOAD LIMIT                          assets/euphoria-upload.js
   Raises the personalisation file upload from 5 MB to 20 MB and corrects the
   labels that quote the figure, in whichever language they are written.

   20 is not a preference — it is Shopify's own hard cap for a line item
   property file. A larger file is refused server-side whatever the storefront
   allows, so 100 MB is not reachable without a third-party upload app that
   stores the file on its own servers.

   The giveaway product template still carries the old 5 MB value in its
   "Euphoria · Personalise" block. Set that block's "Max size (MB)" to 20 in
   the theme editor and this file quietly becomes a no-op: it never touches a
   field that already allows 20 MB or more.
   =========================================================================== */
(function () {
  'use strict';

  var MAX_MB = 20;

  function relabel(field) {
    var labels = field.querySelectorAll('b, span, p');
    for (var i = 0; i < labels.length; i++) {
      var el = labels[i];
      if (el.children.length) { continue; }
      var text = el.textContent;
      if (!/MB|ميجابايت|ميغابايت/i.test(text)) { continue; }
      var next = text.replace(/\b5\b/, String(MAX_MB));
      if (next !== text) { el.textContent = next; }
    }
  }

  function apply() {
    var inputs = document.querySelectorAll('[data-eu-file]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.dataset.euUploadDone === '1') { continue; }
      if (parseFloat(input.getAttribute('data-max-mb')) >= MAX_MB) { continue; }
      input.dataset.euUploadDone = '1';

      /* The block reads data-max-mb at change time, so updating the attribute
         is all it takes to raise the gate. */
      input.setAttribute('data-max-mb', String(MAX_MB));

      var field = input.closest('.eu-field') || input.parentNode;
      relabel(field);

      /* The block caches its hint text when it initialises and restores it
         when the shopper removes a file, so re-apply after it has done that. */
      (function (scope) {
        input.addEventListener('change', function () {
          setTimeout(function () { relabel(scope); }, 0);
        });
      })(field);
    }
  }

  if (document.readyState !== 'loading') { apply(); }
  else { document.addEventListener('DOMContentLoaded', apply); }
})();